import { Alert, AlertTitle, Button, Container, Stack } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
import useLocales from '../hooks/useLocales';
// routes
import { PATH_AUTH } from '../routes/paths';
// components
// import Login from '../pages/auth/Login';

// ----------------------------------------------------------------------

export default function P403() {
  const { logout } = useAuth();
  const { translate } = useLocales();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.message, { variant: 'error' });
    }
  };

  return (
    <Container maxWidth="sm">
      <Alert severity="error" sx={{ mt: 3 }}>
        <AlertTitle>{translate('p403.title')}</AlertTitle>
        {translate('p403.description')}
      </Alert>
      <Stack direction={{ xs: 'column', md: 'row' }} mt={3} gap={3} justifyContent={'center'} alignItems={'center'}>
        <Button to="/" variant="contained" component={RouterLink}>
          {translate('p403.gotohome')}
        </Button>
        <Button onClick={handleLogout} variant="outlined">
          {translate('p403.logout')}
        </Button>
      </Stack>
    </Container>
  );
}
